import React from 'react';
import { Button, Card, Form, Input, InputNumber, Typography } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import {
  LIMIT_METRIC_CHOICES,
  LIMIT_METRIC_VAR,
  login,
  selectors,
  updateMetricLimits,
} from 'state';
import { LockOutlined, UserOutlined } from '@ant-design/icons';
import { formatters } from 'services';
import { commasExact2Digits, SNU } from 'services/formatters';

const LimitMetricSettings: React.FC = () => {
  const dispatch = useDispatch();
  const session = useSelector(selectors.activeSession);
  const [form] = Form.useForm();

  // const [lower, setLower] = React.useState<number>(session.metric_limit_low);
  // const [higher, setHigher] = React.useState<number>(session.metric_limit_high);

  if (session.limit_metric === null) {
    return <div></div>;
  }

  // const localFormatter = (val: SNU) => {
  //   if (val === undefined || val === null) return '';
  //   if (session.limit_metric === LIMIT_METRIC_VAR) {
  //     return formatters.millionNoUnit(val);
  //   }
  //   return formatters.commas2Digits(val);
  // };

  return (
    <div style={{ minWidth: 250 }}>
      <Typography.Title level={4} style={{ display: 'inline-block' }}>
        {LIMIT_METRIC_CHOICES[session.limit_metric]} Metric Limits
      </Typography.Title>
      <Card size={'small'} style={{ paddingRight: 10 }}>
        <Form
          form={form}
          name="change_limit_metric_form"
          initialValues={{
            low_limit: session.metric_limit_low,
            high_limit: session.metric_limit_high,
          }}
          onFinish={() => {
            const data = form.getFieldsValue() as {
              low_limit: number;
              high_limit: number;
            };
            console.log(data);
            dispatch(updateMetricLimits(data));
          }}
          style={{ width: '100%' }}
        >
          <Form.Item name="low_limit" label="low" style={{ marginLeft: '7px' }}>
            {/*<InputNumber style={{ width: 'clamp(170px, 100%, 100%)' }} />*/}
            <InputNumber
              style={{ width: '100%' }}
              formatter={val => formatters.commasExact2Digits(val)}
            />
          </Form.Item>
          <Form.Item name="high_limit" label="high">
            {/*<InputNumber style={{ width: 'clamp(170px, 100%, 100%)' }} />*/}
            <InputNumber
              style={{ width: '100%' }}
              formatter={val => formatters.commasExact2Digits(val)}
            />
          </Form.Item>
          <Form.Item>
            <Button
              htmlType="submit"
              // className="login-form-button"
              // loading={waiting}
              style={{ width: '60px', right: 0, position: 'absolute', top: 0 }}
            >
              Save
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default LimitMetricSettings;
